import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/24-7.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/area-bold.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/area.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/buildings-bold.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/buildings.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/heating.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/landArea.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/landAreaBig.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/lift.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/parking.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/shower-head.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stairs-bold.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/status.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/icon_bed.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/icon_door.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/id-card.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/stairs.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/buttons/home.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/controls/layout-grid.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/feedback/spinner.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/calendar.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/eye.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/navigation/arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/pages/BuyDetail/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToFavorite"] */ "/app/src/components/ui/Common/AddToFavorite/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Amount"] */ "/app/src/components/ui/Common/Amount/Amount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RangeAmount"] */ "/app/src/components/ui/Common/Amount/RangeAmount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Common/EmptyState/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Common/Loader/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Common/LocationTitle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ObjectCard"] */ "/app/src/components/ui/Common/ObjectCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Common/RealtorOnly/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowMore"] */ "/app/src/components/ui/Common/ShowMore/ShowMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/HiddenFieldsView/HiddenFieldsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/IconByName/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/SearchResultHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/SeoHead/SeoHead.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CallButton"] */ "/app/src/components/widgets/Call/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CallBack"] */ "/app/src/components/widgets/CallBack/CallBack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyChanger"] */ "/app/src/components/widgets/CurrencyChanger/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ObjectDetailManagerInfo"] */ "/app/src/components/widgets/ObjectDetail/ManagerInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ObjectDetailSlider"] */ "/app/src/components/widgets/ObjectDetail/Slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyDetailTabs","default"] */ "/app/src/components/widgets/PropertyDetailTabs/PropertyDetailTabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/Realtor/PropertyActionButtons/PropertyActionButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/widgets/Realtor/PropertyActionButtons/PropertyActionButtonsWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/Realtor/PropertyAgentInfo/PropertyAgentInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyAssignment"] */ "/app/src/components/widgets/Realtor/PropertyAssignment/PropertyAssignment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyStatusBadge"] */ "/app/src/components/widgets/Realtor/PropertyStatusBadge/PropertyStatusBadge.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/Realtor/PropertyStatusDisplay/PropertyStatusDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RealtorActionBar"] */ "/app/src/components/widgets/Realtor/RealtorActionBar/RealtorActionBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RealtorActions"] */ "/app/src/components/widgets/Realtor/RealtorActions/RealtorActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useContextMenuActions"] */ "/app/src/components/widgets/Realtor/RealtorContextMenu/hooks/useContextMenuActions.ts");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/Realtor/RealtorContextMenu/RealtorContextMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UniversalContextMenu"] */ "/app/src/components/widgets/Realtor/RealtorContextMenu/UniversalContextMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/Realtor/RealtorWrapper/RealtorWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/widgets/RealtorPropertyDetails/components/ConditionalField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/widgets/RealtorPropertyDetails/components/FieldSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/widgets/RealtorPropertyDetails/components/PhoneDisplay.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/RealtorPropertyDetails/RealtorPropertyDetails.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/widgets/RecommendedList/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Share"] */ "/app/src/components/widgets/Share/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WriteButton"] */ "/app/src/components/widgets/Write/index.tsx");
